import { Switch } from "@mui/material";
// css comes in CreatePublishHomework;
import {
  DatePickerComponent,
  TimePickerComponent,
  DateTimePickerComponent,
} from "@syncfusion/ej2-react-calendars";
import React, { useEffect, useRef, useState } from "react";
import { MultiSelect } from "react-multi-select-component";
import Successfull from "../create_successfull/Successfull";
import axios from "../../../../axios";
import ResponseLoding from "../../../../Homework/Pre-read/Create_Assessment_PreRead/create_successfullPreRead/ResponseLoding";
import ErrorDialog from "./ErrorDialogue";
import { toast } from "react-toastify";

const CreatePublish = ({
  setClick,
  questions,
  assessmentDetails,
  setAssessmentDetails,
  sourceLibrary
}) => {
  const assessmentDialogRef = useRef();
  const [checked, setChecked] = useState(false);
  const [checked1, setChecked1] = useState(false);
  const [lectureDate, setLectureDate] = useState();
  const [errorMessage, setErrorMessage] = useState("");
  const [isError, setIsError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [dValid, setDValid] = useState(true);

  const today = new Date();
  const minDateTime = new Date(today.getTime() + 30 * 60000);
  const disablePastDates = (date) => {
    return date < today;
  };

  const [studentList, setStudentList] = useState([]);
  const [selectedList, setSelectedList] = useState([]);
  const [lectures, setLectures] = useState();
  const [isInProgress, setIsInProgress] = useState(false);

  let schoolId = JSON.parse(localStorage.getItem("schoolId"));
  let academicYearId = JSON.parse(localStorage.getItem("academicYearId"));
  let timeTableSessionId = JSON.parse(
    localStorage.getItem("timeTableSessionId")
  );

  useEffect(() => {
    let students = [];
    const getStudentList = async () => {
      if (!timeTableSessionId) {
        return;
      }
      try {
        let res = await axios.get(
          `/api/v1/school/student/getList?standardId=${assessmentDetails?.standard_id?.id}&sectionId=${assessmentDetails?.section_id?.id}&timetableSession=${timeTableSessionId}`
        );

        res &&
          res.data.data.map((student) =>
            students.push({ value: student.id, label: student.name })
          );

        setStudentList(students);
      } catch (error) {
        if (error.message === "No Internet Connection") {
          alert("No Internet Connection");
          return;
        }
        console.log(error);
      }

      // try {
      //   if (assessmentDetails?.deadline) {
      //     let lectures = await axios.get(
      //       `/api/v1/timetable/getLectureBySubject/academicYearId/${academicYearId}/schoolId/${schoolId}/standardId/${assessmentDetails?.standard_id?.id}/sectionId/${assessmentDetails?.section_id?.id}/timetableSessionId/${timeTableSessionId}/subjectId/${assessmentDetails?.subject_id?.id}/date/${assessmentDetails?.deadline}`
      //     );
      //     lectures && setLectures(lectures?.data?.data[0].lectures);
      //   }
      // } catch (error) {
      //   console.log(error);
      // }
    };

    getStudentList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const getLiveLectureList = async () => {
      if (!academicYearId || !timeTableSessionId) {
        toast.error("These are no allocations set for your login. Please contact school admin for the assistance.")
        return;
      }
      try {
        setLectures([]);
        if (assessmentDetails?.deadline) {
          let lectures = await axios.get(
            `/api/v1/timetable/getLectureBySubject/academicYearId/${academicYearId}/schoolId/${schoolId}/standardId/${assessmentDetails?.standard_id?.id}/sectionId/${assessmentDetails?.section_id?.id}/timetableSessionId/${timeTableSessionId}/subjectId/${assessmentDetails?.subject_id?.id}/date/${lectureDate}`
          );
          lectures && setLectures(lectures?.data?.data[0].lectures);
        }
      } catch (error) {
        console.log(error);
      }
    };

    getLiveLectureList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lectureDate]);

  const handleStudentSelection = (selected) => {
    setSelectedList(selected);
  };

  function convertDateFormat(inputDate) {
    const [day, month, year] = inputDate.split("-");
    const dateObject = new Date(`${year}-${month}-${day}`);
    const convertedYear = dateObject.getFullYear();
    const convertedMonth = String(dateObject.getMonth() + 1).padStart(2, "0");
    const convertedDay = String(dateObject.getDate()).padStart(2, "0");
    const convertedDate = `${convertedYear}-${convertedMonth}-${convertedDay}`;
    return convertedDate;
  }

  const dateHelper = (a) => {
    const dateObj = new Date(a);
    const day = dateObj.getUTCDate();
    const month = dateObj.getUTCMonth() + 1;
    const year = dateObj.getUTCFullYear();
    const outputDateString = `${year}-${month}-${day}`;
    return outputDateString;
  };
  // const dateHelper2 = (a) => {
  //   const dateObj = new Date(a);
  //   const day = dateObj.getUTCDate();
  //   const month = dateObj.getUTCMonth() + 1;
  //   const year = dateObj.getUTCFullYear();
  //   const outputDateString = `${year}-${month}-${day}`;
  //   console.log(outputDateString);
  //   return outputDateString;
  // };

  const timeHelper = (a) => {
    const dateObj = new Date(a);
    const hours = dateObj.getUTCHours();
    const minutes = dateObj.getUTCMinutes();
    const outputDateString = `${hours}:${minutes}`;
    return outputDateString;
  };

  const handleCreateAssessment = async () => {
    setIsInProgress(true);
    let newAssessment = {
      name: assessmentDetails.name,
      description: assessmentDetails.description,
      type_id: assessmentDetails.type_id,
      standard_id: assessmentDetails.standard_id?.id,
      subject_id: assessmentDetails.subject_id?.id,
      teacher_id: assessmentDetails.teacher_id,
      section_id: assessmentDetails.section_id?.id,
      tags: assessmentDetails.tags,
      status: "published",
      total_duration: assessmentDetails.total_duration,
      deadline: assessmentDetails.deadline,
      schedule_date: assessmentDetails.schedule_date,
      schedule_time: assessmentDetails.schedule_time,
      add_to_live_session: assessmentDetails.add_to_live_session,
      questions: questions,
    };

    let students_id = [];
    for (const student of selectedList) {
      students_id.push(student.value);
    }
    try {
      let res = await axios.post(`/api/v1/assessment/create`, newAssessment);
      if (res) {
        let students_id = [];
        for (const student of selectedList) {
          students_id.push(student.value);
        }
        let newStudentAssessment = {
          teacher_id: assessmentDetails?.teacher_id,
          student_id: students_id,
          status: "pending",
          deadline: assessmentDetails?.deadline,
          totalDuration: parseInt(assessmentDetails?.total_duration),
        };
        let studentRes = await axios.post(
          `/api/v1/assessment/${res?.data?.data?.id}/studentAssessment/create`,
          newStudentAssessment
        );
        studentRes && setSuccess(!success);
      }
    } catch (error) {
      setIsInProgress(false);
      console.log(error);
      setIsError(true);
      if (error.response.data.message) {
        setErrorMessage(error.response.data.message);
      }
      assessmentDialogRef.current.openDialog();
    }
  };
  const handleDateChange = (selectedDate) => {
    const selected = dateHelper(selectedDate.target.value);
    const today = new Date().toISOString().split("T")[0];

    const selectedDateObject = new Date(selected);
    const todayDateObject = new Date(today);
    selectedDateObject.setHours(0, 0, 0, 0);
    todayDateObject.setHours(0, 0, 0, 0);

    if (selectedDateObject < todayDateObject) {
      setDValid(false);
      setAssessmentDetails({
        ...assessmentDetails,
        deadline: today,
      });
    } else {
      setDValid(true);
      setAssessmentDetails((prevDetails) => ({
        ...prevDetails,
        deadline: selectedDate.target.value,
      }));
    }
  };

  const handleKeyDown = (e) => {
    const keyPressed = e.key;
    // Regular expression to allow only date-related characters
    const allowedCharacters = /[0-9/\-]/; // Adjust this regex based on your date format

    if (!allowedCharacters.test(keyPressed)) {
      e.preventDefault();
      setDValid(false);
    }
  };

  const calculateMinTime = () => {
    if (assessmentDetails?.schedule_date) {
      const startDate = new Date(assessmentDetails.schedule_date);
      if (today.getDate() === startDate.getDate()) {
        startDate.setTime(today.getTime() + 30 * 60000);
      } else {
        startDate.setHours(0, 0, 0, 0);
      }
      return startDate;
    } else {
      // If no date is selected, start from current time + 30 minutes
      const now = new Date();
      now.setMinutes(now.getMinutes() + 30);
      return now;
    }
  };
  function formatDate(inputDate) {
    const dateObject = new Date(inputDate);

    const year = dateObject.getFullYear();
    const month = String(dateObject.getMonth() + 1).padStart(2, "0");
    const day = String(dateObject.getDate()).padStart(2, "0");

    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  }
  const deadline = assessmentDetails?.schedule_date;
  if (deadline) {
    var minLiveSessionDate = new Date(deadline);
    minLiveSessionDate.setDate(minLiveSessionDate.getDate() - 6);

    var maxLiveSessionDate = new Date(deadline);
    maxLiveSessionDate.setDate(maxLiveSessionDate.getDate() + 28);
  }
  function convertTimeStringToAMPM(timeString) {
    if (timeString.length !== 4) {
      // Ensure the input string has the correct length
      console.error("Invalid time string format");
      return null;
    }

    const hours = timeString.substring(0, 2);
    const minutes = timeString.substring(2);

    const formattedTime = `${hours}:${minutes} ${hours < 12 ? "AM" : "PM"}`;
    return formattedTime;
  }
  return (
    <>
      <ErrorDialog
        error={"Cannot create assessment"}
        message={errorMessage}
        ref={assessmentDialogRef}
        setIsError={setIsError}
      />
      {!success && (
        <div className="publish_transprant_body1">
          <div className=" p-4 publish_white_containerPre">
            <img
              src="/images/cross-circle3.svg"
              className="subPrereadClosetBtn"
              alt=""
              onClick={(e) => setClick(false)}
            />
            <div className="PublishHeader">
              <h5 className="publish_header">Publish</h5>
              <p className="DisplayTag">
                <span style={{ fontWeight: "400" }}>Tags: </span>
                {assessmentDetails.tags.map((tag, index) => (
                  <span
                    style={{ color: "black", fontWeight: "600" }}
                    key={index}
                  >
                    {tag}
                    {index !== assessmentDetails.tags.length - 1 ? "," : ""}
                  </span>
                ))}
              </p>
            </div>
            <div className=" col-12 publish_field_boxs">
              {assessmentDetails?.subject_id?.name}
            </div>
            <div className=" col-12 publish_field_boxs">
              {assessmentDetails?.standard_id?.name}
            </div>
            <div className=" col-12 publish_field_boxs">
              {assessmentDetails?.section_id?.name}
            </div>
            {/* <div className=" col-12 m-0 p-0 px-2 EnterDeadlinePreread">
              <DateTimePickerComponent
                placeholder="Deadline"
                id="datepicker"
                //format='yyyy-MM-dd'
                value={assessmentDetails?.deadline}
                min={minDateTime}
                onChange={(e) => handleDateChange(e)}
                onKeyDown={(e) => handleKeyDown(e)}
              />
            </div> */}
            {/* <span style={{ color: "red" }}>
              {!dValid && "Min. date selected must be for today."}
            </span> */}
            <div className="my-3">
              <MultiSelect
                options={studentList}
                value={selectedList}
                onChange={handleStudentSelection}
                labelledBy="Select"
                overrideStrings={{ selectSomeItems: "Select Students" }}
                className="custom-multiselect w-100"
              />
              <span style={{ color: "red", fontSize: "10px" }}>
                {selectedList.length <= 0 && "Select atleast one student"}
              </span>
            </div>

            <div className="btn_containers">
              <div className="toggle_btn">
                <div className="schedule_btns">
                  <span>Schedule</span>
                  <label className="switch">
                    <Switch
                      className="switch"
                      checked={checked}
                      onChange={(event) => {
                        setChecked(event.target.checked);
                        setChecked1(false);

                        setAssessmentDetails({
                          ...assessmentDetails,
                          schedule_date: null,
                          schedule_time: null,
                        });
                      }}
                    />
                  </label>
                </div>
                {checked && (
                  <>
                    {/* id css define in createPublishPreRead.css */}
                    <div className=" schedule_box ">
                      <DatePickerComponent
                        allowEdit={false}
                        min={today}
                        isDateDisabled={disablePastDates}
                        id="datepicker"
                        placeholder="Scheduled date"
                        value={assessmentDetails?.schedule_date}
                        onChange={(e) => {
                          if (!e.target.value) {
                            setAssessmentDetails({
                              ...assessmentDetails,
                              schedule_date: "",
                            });
                            setChecked1(false);
                          } else {
                            setAssessmentDetails({
                              ...assessmentDetails,
                              schedule_date: dateHelper(e.target.value),
                            });
                          }
                          handleDateChange(e);
                        }}
                      />
                    </div>
                    <div className="schedule_box  ">
                      <TimePickerComponent
                        min={calculateMinTime()}
                        isDateDisabled={disablePastDates}
                        id="timepicker"
                        placeholder="Scheduled time"
                        onChange={(e) =>
                          setAssessmentDetails({
                            ...assessmentDetails,
                            schedule_time: timeHelper(e.target.value),
                          })
                        }
                      />

                    </div>
                    <span style={{ color: "red" }}>
                      {!dValid && "Min. date selected must be for today."}
                    </span>
                  </>
                )}
              </div>
              <div className="toggle_btn">
                <div className=" schedule_btns p-1 ml-1">
                  {deadline ? (
                    <label className="switch">
                      <DatePickerComponent
                        id="datepicker"
                        placeholder="Add to Lecture Session"
                        width={230}
                        min={minLiveSessionDate}
                        max={maxLiveSessionDate}
                        allowEdit={false}
                        onChange={(e) => {
                          if (!e.target.value) {
                            setLectureDate(null);
                          } else {
                            setChecked1(true);
                            setLectureDate(formatDate(e.target.value));
                          }
                        }}
                      />
                    </label>
                  ) : (
                    <>
                      <label className="deadlineNotSelect pb-1 pl-1">
                        Add to Lecture Session
                      </label>
                      <img
                        src="/images/calIconDow.png"
                        alt=""
                        className="calDow"
                      />
                    </>
                  )}
                </div>
                {checked1 && (
                  <div className="schedule_box border-0 p-0 ml-1">
                    <select
                      className="form-select col-12 py-2 m-0  "
                      id="Schedule_sesion"
                      style={{ margin: "0px" }}
                      onChange={(e) =>
                        setAssessmentDetails({
                          ...assessmentDetails,
                          add_to_live_session: {
                            lecture_id: e.target.value,
                            date: convertDateFormat(
                              e.target.options[
                                e.target.selectedIndex
                              ].getAttribute("date")
                            ),
                          },
                        })
                      }
                    >
                      <option selected>Select Lecture</option>
                      {lectures?.length > 0 &&
                        lectures?.map((lecture, index) => (
                          <option
                            key={index}
                            value={lecture.id}
                            date={lecture.date}
                          >
                            {lecture.name}, {lecture.date},{" "}
                            {convertTimeStringToAMPM(lecture.start_time)}-
                            {convertTimeStringToAMPM(lecture.end_time)}
                          </option>
                        ))}
                    </select>
                  </div>
                )}
              </div>
            </div>

            <div className="publish_btn_box">
              <button
                disabled={
                  !dValid ||
                  // !assessmentDetails.schedule_date ||
                  // !assessmentDetails.schedule_time ||
                  !selectedList.length > 0 ||
                  (checked1 && lectures?.length > 0 &&
                    (!assessmentDetails?.add_to_live_session?.lecture_id ||
                      !assessmentDetails?.add_to_live_session?.date))
                }
                className="btn publish_btn"
                onClick={handleCreateAssessment}
              >
                Publish
              </button>
            </div>
          </div>
        </div>
      )}
      {success && <Successfull setSuccess={setSuccess} />}
      {!success && isInProgress && (
        // <div className="loader_bg">
        <ResponseLoding />
        // {/* </div> */}
      )}
    </>
  );
};

export default CreatePublish;
